import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NuclearObservable } from '../nuclear-observable'
import { BaseComponent } from '../components/base.component'
import { userGetters } from '../stores/user-store'
import { customerGetters } from '../stores/customer-store'
import { Customer } from '../types'
import { CustomerActions } from '../actions/customer-actions'


@Component({
  selector: 'customer-writer-profile-page',
  template: `
    <header-only-layout>
      <div header>
        <nav-bar></nav-bar>
      </div>
      <div main>
        <div class="row mt-3">
          <div class="col-auto">
            <button class="btn btn-default" (click)="backClicked()">
              <span class="fas fa-arrow--left"></span>
              Go Back
            </button>
          </div>
          <div class="col">
            <h3>{{customer?.businessName}}</h3>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12">
            <writer-profile *ngIf="customerId && writerSlug" [writerSlug]="writerSlug" [customerId]="customerId"></writer-profile>
          </div>
        </div>
      </div>
    </header-only-layout>
  `
})
export class CustomerWriterProfilePage extends BaseComponent implements OnInit {
  customerId: number;
  writerSlug: string;
  customer: Customer;

  constructor(private route: ActivatedRoute, private router: Router, private customerActions: CustomerActions) {
    super()
  }

  ngOnInit() {
    const routeObs = this.route.params.subscribe(params => {
      this.clearRouteObservers()
      this.customerId = +params['customerId']
      this.writerSlug = params['writerSlug']

      if (this.customerId) {
        this.customerActions.loadCustomer(this.customerId)
        const custObs = NuclearObservable.from<Customer>(customerGetters.customer(this.customerId), { toJS: true }).subscribe(c => this.customer = c)
        this.routeObservers.push(custObs)
      }
    })
    this.observers.push(routeObs)
  }

  backClicked(): void {
    const uiState = NuclearObservable.currentValue<any>(userGetters.uiState, { toJS: true })
    const lastDashboardPath = uiState.lastDashboardPath
    if (lastDashboardPath) {
      this.router.navigateByUrl(lastDashboardPath)
    } else {
      this.router.navigate(['/dashboard', this.customerId])
    }
  }
}
